import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

import TouchNavGroup from '../../common/components/navpanel/TouchNavGroup';
import BasicLayout from '../../common/components/CustomLayout/BasicLayout';

import Manufactures from './manufactures/Manufactures';
import Tags from './tags/Tags';
import Locations from './locations/Locations';
import Users from './users/Users';

import { ScrollView } from 'react-native-gesture-handler';
import Documents from './documents/Documents';
import ReservationTypes from './reservationtypes/ReservationTypes';
import Trucks from './trucks/Trucks';
import StoreDetails from './storedetails/StoreDetails';
import DiscountCodes from './dicountcodes/DiscountCodes';
import Taxcodes from './taxcodes/Taxcodes';
import Colorcombinations from './colorcombinations/Colorcombinations';
import Extras from './Extras/Extras';
import { Templates } from './templates/Templates';
import ProductCompatibility from './productcompatibility/ProductCompatibility';
import PMC from './pmc/PMC';
import BlockDates from './blockdate/BlockDates';
import GeneralSettings from './general/GeneralSettings';
import ManageKeys from '../Inventory/managekeys/ManageKeys';
import CMSContent from './cms/CMSContent';
import PlatformBillingScreen from './platformbilling/PlatformBillingScreen';

interface Props {
    navigation: any;
    route?: any;
    initialItem?: string;
}

const Settings = ({ navigation, route, initialItem }: Props) => {
    const routeInitialItem = route?.params?.initialItem;
    const routeInitialBrandId = route?.params?.initialBrandId;
    const [selectedItem, setSelectedItem] = useState<string>(routeInitialItem || initialItem);
    const [cmsInitialBrandId, setCmsInitialBrandId] = useState<string>(routeInitialBrandId || '');

    useEffect(() => {
        if (routeInitialItem) {
            setCmsInitialBrandId(routeInitialBrandId || '');
            setSelectedItem(routeInitialItem);
        }
    }, [routeInitialItem, routeInitialBrandId]);

    const handleItemClick = (itemName) => {
        setSelectedItem(itemName);
    };

    // Legacy System A (manage_keys) editor is still reachable on dev hosts only.
    const isLegacyManageKeysEnabled = () => {
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname;
            return hostname === 'localhost' || hostname === '127.0.0.1';
        }
        return false;
    };

    if (selectedItem) {
        switch (selectedItem) {
            case 'Manufactures':
                return <Manufactures navigation={navigation} openInventory={handleItemClick} />;
            case 'Tag Management':
                return <Tags navigation={navigation} openInventory={handleItemClick} />;
            case 'Store Locations':
                return <Locations navigation={navigation} openInventory={handleItemClick} />;
            case 'Document Management':
                return <Documents navigation={navigation} openInventory={handleItemClick} />;
            case 'Reservation Types':
                return <ReservationTypes navigation={navigation} openInventory={handleItemClick} />;
            case 'Trucks':
                return <Trucks navigation={navigation} openInventory={handleItemClick} />;
            // case 'Store Details':
            //     return <StoreDetails navigation={navigation} openInventory={handleItemClick}/>;
            case 'Discount Codes':
                return <DiscountCodes navigation={navigation} openInventory={handleItemClick} />;
            case 'Tax Codes':
                return <Taxcodes navigation={navigation} openInventory={handleItemClick} />;
            case 'Color Combinations':
                return <Colorcombinations navigation={navigation} openInventory={handleItemClick} />;
            case 'Extras':
                return <Extras navigation={navigation} openInventory={handleItemClick} />;
            case 'Templates':
                return <Templates navigation={navigation} openInventory={handleItemClick} />;
            case 'Product Compatability':
                return <ProductCompatibility navigation={navigation} openInventory={handleItemClick} />;
            case 'PMC':
                return <PMC navigation={navigation} openInventory={handleItemClick} />;
            case 'Block Dates':
                return <BlockDates navigation={navigation} openInventory={handleItemClick} />;
            case 'General Settings':
                return <GeneralSettings navigation={navigation} openInventory={handleItemClick} />;
            case 'User Management':
                return <Users navigation={navigation} openInventory={handleItemClick} />;
            case 'CMS Settings':
                return <CMSContent navigation={navigation} goBack={() => handleItemClick(null)} initialBrandId={cmsInitialBrandId} />;
            case 'CMS Settings (Legacy)':
                return <ManageKeys navigation={navigation} goBack={() => handleItemClick(null)} initialBrandId={cmsInitialBrandId} />;
            case 'Platform Billing':
                return <PlatformBillingScreen navigation={navigation} openInventory={handleItemClick} />;
            default:
                return (
                    <View style={{ marginTop: 20, paddingHorizontal: 10, paddingVertical: 2, height: 28, justifyContent: 'center', flexDirection: 'row', }}>
                        <TouchableOpacity onPress={() => handleItemClick(null)}>
                            <Text>{'< Back'}</Text>
                        </TouchableOpacity>
                        <Text style={{ fontSize: 28 }}>{selectedItem}</Text>
                    </View>
                );
        }
    };

    const settingsItems = [
        { title: "Manufactures", icon: 'industry' },
        { title: "Tag Management", icon: 'tags' },
        { title: "Store Locations", icon: 'route' },
        { title: "Document Management", icon: 'sticky-note' },
        // { title: "Reservation Types", icon: 'calendar-check' },
        { title: "Trucks", icon: 'truck' },
        // { title: "Store Details", icon: 'store' },
        { title: "Discount Codes", icon: 'percentage' },
        { title: "Tax Codes", icon: 'money-check-alt' },
        { title: "Color Combinations", icon: 'palette' },
        { title: "Extras", icon: 'plus-circle' },
        // { title: "Templates", icon: 'mail-bulk' },
        { title: "Product Compatability", icon: 'project-diagram' },
        { title: "PMC", icon: 'project-diagram' },
        { title: "Block Dates", icon: 'snowman' },
        { title: "General Settings", icon: 'cog' },
        { title: "User Management", icon: 'users' },
        { title: "Platform Billing", icon: 'credit-card' },
    ];

    // Unified CMS editor (System B) available to all admins.
    settingsItems.push({ title: "CMS Settings", icon: 'file-alt' });

    // Legacy raw key/value editor kept on dev hosts only during transition.
    if (isLegacyManageKeysEnabled()) {
        settingsItems.push({ title: "CMS Settings (Legacy)", icon: 'key' });
    }

    return (
        <BasicLayout
            navigation={navigation}
            screenName={"Settings"}
        >
            <ScrollView>
                <View style={styles.container}>
                    <TouchNavGroup sectionTitle="Settings" items={settingsItems} handleItemClick={handleItemClick} />
                </View>
            </ScrollView>
        </BasicLayout>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 20,
        width: '90%',
        maxWidth: 1000,
        margin: 'auto',
        marginTop: 40,
    },
});

export default Settings;
